module.exports = __webpack_public_path__ + "static/logo-jaguar-17beb8b7b804c321f89807f81c37d573.png";